<template>
<div class="alarm-modal-wrapper">
    <h3>Alarm Modal</h3>
    <div class="alarm"> {{ JSON.stringify(alarm) }} </div>
</div>
</template>

<script>
export default {
    name: "AlarmModal",
    props:{
        alarm: Object
    }
}
</script>